import React from "react";
import AuthShell from "./AuthShell";

const SignupPage = () => (
  <AuthShell
    mode="signup"
    testIdPrefix="signup"
    eyebrow="Unisciti a noi"
    headline="Join Napoli Rewards"
    subhead="Earn 100 points just for joining. Redeem on your next visit."
    footer={{
      label: "Already a member?",
      linkText: "Sign in →",
      to: "/login",
    }}
  />
);

export default SignupPage;
